import type { CompanyFollower } from "@/modules/companies/client/api/types"

import { useQuery } from "@tanstack/react-query"
import { useParams } from "next/navigation"

import { getCompanyFollower } from "@/modules/companies/client/api/endpoints/companyFollower"
import { COMPANY_FOLLOWER_QUERY_KEY } from "@/modules/companies/client/api/endpoints/constants"
import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/companies/client/constants/enums"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

type CompanyFollowerFetch = {
  dataCompanyFollower?: CompanyFollower
  isLoadingCompanyFollower: boolean
  isSuccessCompanyFollower: boolean
  isErrorCompanyFollower: boolean
}
export const useCompanyFollowerFetch = (): CompanyFollowerFetch => {
  const { companySlug } = useParams<{ companySlug: string }>()
  const { dataCompany } = useCompanyFetch()

  const {
    data: dataCompanyFollower,
    isPending: isLoadingCompanyFollower,
    isSuccess: isSuccessCompanyFollower,
    isError: isErrorCompanyFollower,
  } = useQuery({
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getCompanyFollower({ permalink: companySlug }),
    queryKey: [COMPANY_FOLLOWER_QUERY_KEY, dataCompany?.id, companySlug],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCompanyFollower,
    isErrorCompanyFollower,
    isLoadingCompanyFollower,
    isSuccessCompanyFollower,
  }
}
